export default __webpack_public_path__ + "static/media/logo-header.0c67a976.svg";